import React, { PureComponent } from 'react'
import { Panel, Glyphicon, Button } from 'react-bootstrap'
import { reduxForm } from 'redux-form'
import SimpleTablePage from '../../../../containers/commons/general/SimpleTablePage'
import ConditionDetailsFleetModalPage from '../../../../containers/management/fleets/conditions/ConditionDetailsFleetModalPage'
import { compareValues } from '../../../../util/utils'
import { fleetsTab } from '../../../../constants/management/fleets'

class ConditionsListComponent extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      openConditionPanel: true,
      dossiers: [],
      numDossiers: 0,
      filters: {
        orderBy: '+condition'
      }
    }
  }

  updateList () {
    this.props.actions.getConditionFleetList(this.props.dossiers)
    this.setState({ numDossiers: this.props.dossiers.length, dossiers: this.props.dossiers })
  }

  collapsePanelConditions () {
    this.setState({ openConditionPanel: !this.state.openConditionPanel })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.tabActiveKey !== this.props.tabActiveKey && this.props.tabActiveKey === fleetsTab.FLEETS_CONDITIONS && this.props.dossiers && this.props.dossiers.length > 0) {
      this.updateList()
    } else if (prevProps.tabActiveKey !== this.props.tabActiveKey && this.props.tabActiveKey !== fleetsTab.FLEETS_CONDITIONS && prevProps.tabActiveKey === fleetsTab.FLEETS_CONDITIONS) {
      this.setState({ dossiers: [], numDossiers: 0 })
      this.props.actions.closeConditionsFleetComponent()
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    return null
  }

  getIconClass (field) {
    if (this.state.filters.orderBy.includes(field)) {
      return this.state.filters.orderBy.includes('-') ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  onOrderChange (e) {
    const newOrderBy = this.state.filters.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
    this.setState({ filters: { orderBy: newOrderBy } })
    this.order(e.currentTarget.dataset.field, newOrderBy.includes('+') ? 'asc' : 'desc')
  }

  order (field, order) {
    let conditions = JSON.parse(JSON.stringify(this.props.conditionsFleetList))
    conditions = conditions.sort(compareValues(field, order))
    this.props.actions.getConditionFleetListSuccess(conditions)
  }

  detailCondition (condition) {
    this.props.actions.openConditionDetailsFleetModal(condition, this.props.dossierFleetDetails.find(doc => doc.dossierId === this.props.dossiers[0])?.stage)
  }

  modify () {
    this.props.moveToModifyConditionsSelection()
  }

  render () {
    const {
      t,
      conditionsFleetList
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    let subTitle = t(`${tKey}NUM_SELECTED_DOSSIERS`).replace('##NUM_SELECTED##', this.state.numDossiers).replace('##NUM_TOTAL##', this.props.dossierFleetDetails.length)
    let bar = ' | '
    let stage = (this.props.dossiers && this.props.dossiers.length > 0) ? (` - ${this.props.dossierFleetDetails.find(doc => doc.dossierId === this.props.dossiers[0])?.stage}`) : ''
    subTitle += stage

    return (
      <div id='conditionsListComponent'>
        <ConditionDetailsFleetModalPage
          dossierList={this.props.dossiers}
          openConditionsFleetComponent={this.props.openConditionsFleetComponent}
          tabActiveKey={this.props.tabActiveKey}
        />
        <div className="dossier-panel" >
          <div className="header-panel  fleet-panel-box" onClick={() => this.collapsePanelConditions()}>

            <div className="name-wrapper fleet-panel-box-title">
              <h4>{t(`${tKey}CONDITIONS`)}{bar}<span className='fleet-panel-subTitle'>{`${subTitle}`}</span></h4>
            </div>

            <i className={this.state.openConditionPanel ? 'ico-arrow-black-down fleet-panel-box-caret' : 'ico-arrow-black-up fleet-panel-box-caret'} />

          </div>
          <Panel expanded={this.state.openConditionPanel} onToggle={() => {}}>
            <Panel.Collapse>
              <div id="fleet-dossier-details-table" className='_nf'>
                <div className="flexInLine al-R">
                  <Button
                    id="conditionListComponent_modifySelection_button"
                    className="_Btn accept stk"
                    onClick = {() => this.modify()}>
                    {t('MANAGEMENT.FLEETS_TAB.MODIFY_SELECTION')}
                  </Button>
                </div>
                {(this.props.dossiers && this.props.dossiers.length > 0) ? <SimpleTablePage
                  columns={[
                    <th key={0} data-field="conditionTypeUseId" style={{ display: 'none' }}>
                    </th>,
                    <th key={1} data-field="condition" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}CONDITION`)}&nbsp;<i className={this.getIconClass('condition')}></i>
                    </th>,
                    <th key={2} data-field="category" onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}CATEGORY`)}&nbsp;<i className={this.getIconClass('category')}/>
                    </th>,
                    <th key={3} data-field="requested" className='actions' onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}REQUESTED_CONDITION`)}&nbsp;<i className={this.getIconClass('requested')}></i>
                    </th>,
                    <th key={4} data-field="fulfilled" className='actions' onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}FULFILLED`)}&nbsp;<i className={this.getIconClass('fulfilled')}/>
                    </th>,
                    <th key={5} data-field="status" className='actions' onClick={(event) => this.onOrderChange(event)}>
                      {t(`${tKey}STATUS`)}&nbsp;<i className={this.getIconClass('status')}/>
                    </th>,
                    <th key={6} data-field="detail" className='actions flet-detail-dossier-check-title' >
                      {t(`${tKey}DETAIL`)}&nbsp;<i className={this.getIconClass('detail')}/>
                    </th>
                  ]}
                  rows={conditionsFleetList && conditionsFleetList.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.condition}</td>
                      <td>{t(`${tKey}${row.category}`)}</td>
                      <td className='actions'>{row.requested}</td>
                      <td className='actions'>{row.fulfilled}</td>
                      <td className='actions'>{<i className={'icon-action ' + (row.status ? 'iDocIcon-done-ok' : 'iDocIcon-warning')}/>}</td>
                      <td className='actions'>{
                        <a onClick={() => this.detailCondition(row)}>
                          <Glyphicon className='icon-action blue' glyph="eye-open"/>
                        </a>
                      }
                      </td>
                    </tr>
                  ))}

                ></SimpleTablePage>
                  : <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
                }
              </div>

            </Panel.Collapse>
          </Panel>
        </div>
      </div>
    )
  }
}

export default reduxForm({
  form: 'ConditionsListComponent'
})(ConditionsListComponent)
